
export class CurrentUserProfile {
    public avatarImageId: string;
    public originAvatarImageId: string;
    public avatarImageUrl: string;
    public bio: string;
    public city: string;
    public state: string;
    public country: string;
    public phoneNumber: string;
    public twitter: string;
    public linkedin: string;

    constructor(obj: any) {
        this.avatarImageId = obj.avatar_image_id;
        this.originAvatarImageId = obj.origin_avatar_image_id;
        this.avatarImageUrl = obj.avatar_image_url;
        this.bio = obj.bio;
        this.city = obj.city;
        this.state = obj.state;
        this.country = obj.country;
        this.phoneNumber = obj.phone_number;
        this.twitter = obj.twitter_handle;
        this.linkedin = obj.linkedin_url;
    }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./public/app/classes/current.user/current.user.profile.ts